module.exports = __webpack_public_path__ + "static/media/leadloop-old.c7323dae.svg";